/* eslint-disable react-hooks/exhaustive-deps */
import React, {FC, createContext, useContext, useEffect, useState} from 'react'
import {WithChildren, toAbsoluteUrl} from '../../helpers'
import {KTIcon} from '../../helpers'
import {Link, useLocation, useParams} from 'react-router-dom'
import Layout from './Layout'

export interface PageLink {
  title: string
  path: string
  isActive: boolean
  isSeparator?: boolean
}

export interface PageDataContextModel {
  pageTitle?: string
  setPageTitle: (_title: string) => void
  pageDescription?: string
  setPageDescription: (_description: string) => void
  pageBreadcrumbs?: Array<PageLink>
  setPageBreadcrumbs: (_breadcrumbs: Array<PageLink>) => void
}

const PageDataContext = createContext<PageDataContextModel>({
  setPageTitle: (_title: string) => {},
  setPageBreadcrumbs: (_breadcrumbs: Array<PageLink>) => {},
  setPageDescription: (_description: string) => {},
})

const PageDataProvider: FC<WithChildren> = ({children}) => {
  const [pageTitle, setPageTitle] = useState<string>('')
  const [pageDescription, setPageDescription] = useState<string>('')
  const [pageBreadcrumbs, setPageBreadcrumbs] = useState<Array<PageLink>>([])

  const value: PageDataContextModel = {
    pageTitle,
    setPageTitle,
    pageDescription,
    setPageDescription,
    pageBreadcrumbs,
    setPageBreadcrumbs,
  }
  return <PageDataContext.Provider value={value}>{children}</PageDataContext.Provider>
}

function usePageData() {
  return useContext(PageDataContext)
}

type Props = {
  description?: string
  breadcrumbs?: Array<PageLink>
  title?: string
  icon?: string
  desc?: string
  tabs?: Array<{slug: string; title: string; href: string; badgeValue?: string}>
  activeTab?: string
  sideButtonGroup?: React.ReactNode
}

const TrustPageTitle: FC<Props & WithChildren> = ({
  children,
  description,
  breadcrumbs,
  title,
  icon,
  desc,
  tabs,
  activeTab,
  sideButtonGroup,
}) => {
  const {setPageTitle, setPageDescription, setPageBreadcrumbs} = usePageData()
  const location = useLocation()
  const {id} = useParams()

  useEffect(() => {
    if (children) {
      setPageTitle(children.toString())
    }
    return () => {
      setPageTitle('')
    }
  }, [children])

  useEffect(() => {
    if (description) {
      setPageDescription(description)
    }
    return () => {
      setPageDescription('')
    }
  }, [description])

  useEffect(() => {
    if (breadcrumbs) {
      setPageBreadcrumbs(breadcrumbs)
    }
    return () => {
      setPageBreadcrumbs([])
    }
  }, [breadcrumbs])

  return (
    // <>
    //   {icon ? (
    //     <div className={`card mb-5 mb-xl-8`}>
    //       <div className='card-header border-0 pt-5 mb-5'>
    //         <div className='d-flex align-items-center'>
    //           <div className='symbol symbol-45px me-5 '>
    //             <img src={toAbsoluteUrl(`/media/logos/${icon}`)} alt='' />
    //           </div>
    //           <div className='d-flex justify-content-start flex-column'>
    //             <span className='card-label fw-bold fs-5'>{title}</span>
    //             <span className='fw-semibold fs-6' style={{color: '#5A5A5A'}}>
    //               {desc}
    //             </span>
    //           </div>
    //         </div>
    //         <button
    //           className='btn btn-sm btn-outline border-2 d-flex align-items-center fs-6'
    //           style={{background: '', height: '35px', color: '#000'}}
    //           onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
    //             (e.currentTarget.style.backgroundColor = '#f1f1f1')
    //           }
    //           onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
    //             (e.currentTarget.style.backgroundColor = '')
    //           }
    //           //   onClick={() =>
    //           //     currentUser?.account_type === 'Trial' ? setShowModal(true) : handleOpenModal()
    //           //   }
    //         >
    //           <svg
    //             xmlns='http://www.w3.org/2000/svg'
    //             width='18'
    //             height='18'
    //             viewBox='0 0 24 24'
    //             fill='none'
    //             stroke='currentColor'
    //             stroke-width='2'
    //             stroke-linecap='round'
    //             stroke-linejoin='round'
    //             className='icon icon-tabler icons-tabler-outline icon-tabler-external-link mb-1'
    //           >
    //             <path stroke='none' d='M0 0h24v24H0z' fill='none' />
    //             <path d='M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6' />
    //             <path d='M11 13l9 -9' />
    //             <path d='M15 4h5v5' />
    //           </svg>
    //           <span className='ms-2'>View</span>
    //         </button>
    //       </div>
    //       {/*begin::Navs*/}
    //       <div className='px-10 '>
    //         <div className='d-flex  h-55px'>
    //           <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-semibold flex-nowrap '>
    //             <li className='nav-item'>
    //               <Link
    //                 to={'/trust'}
    //                 className={`nav-link me-6 ${
    //                   activeTab === 'security-profile' ? 'text-active-primary active' : ''
    //                 }`}
    //               >
    //                 Security Profile
    //               </Link>
    //             </li>

    //             <li className='nav-item'>
    //               <Link
    //                 to={'/trust/monitoring'}
    //                 className={`nav-link me-6 ${
    //                   activeTab === 'monitoring' ? 'text-active-primary active' : ''
    //                 }`}
    //               >
    //                 Monitoring
    //               </Link>
    //             </li>
    //             <li className='nav-item'>
    //               <Link
    //                 to={`/trust/settings`}
    //                 className={`nav-link me-6 ${
    //                   activeTab === 'settings' ? 'text-active-primary active' : ''
    //                 } `}
    //               >
    //                 Settings
    //               </Link>
    //             </li>
    //           </ul>
    //         </div>
    //       </div>
    //       {/* </div> */}
    //       {/*begin::Navs*/}
    //     </div>
    //   ) : null}
    // </>

    <>
      {icon ? (
        <Layout
          icon={icon}
          title={title}
          desc={desc}
          sideButtonGroup={sideButtonGroup}
          tabs={tabs}
          activeTab={activeTab}
        />
      ) : null}
    </>
  )
}

const PageDescription: FC<WithChildren> = ({children}) => {
  const {setPageDescription} = usePageData()
  useEffect(() => {
    if (children) {
      setPageDescription(children.toString())
    }
    return () => {
      setPageDescription('')
    }
  }, [children])
  return <></>
}

export {PageDescription, TrustPageTitle, PageDataProvider, usePageData}
